import Store from './store'

export default function dejaVue<T extends Store>(store: T) {
    return {
        install(Vue: any) {
            Vue.prototype.$database = Vue.observable(store.init())
        }
    }
}
